module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.83ecc850.jpeg";